import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Landing route invoked by the Chrome extension after a successful capture submit.
 * The extension redirects to /x/ticket/:ticketId and we bounce to the full
 * ticket page after a brief splash (keeps the route debuggable).
 */
export function ExtensionHandoffPage() {
  const [params] = useSearchParams();
  const ticketId = params.get('t');
  const navigate = useNavigate();

  useEffect(() => {
    if (ticketId) {
      const timer = setTimeout(
        () => navigate(`/tickets/${ticketId}`, { replace: true, state: { focusDescription: true } }),
        300,
      );
      return () => clearTimeout(timer);
    }
  }, [ticketId, navigate]);

  return (
    <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', color: 'var(--text-tertiary)' }}>
      Opening captured ticket…
    </div>
  );
}
